"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CommonModule_1 = __importDefault(require("../store/CommonModule"));
const vuex_module_decorators_1 = require("vuex-module-decorators");
const CookieStorageService_1 = require("./CookieStorageService");
const CookieKeysEnum_1 = require("../enums/CookieKeysEnum");
const QuestelServicesClient_1 = require("../QuestelServicesClient");
const SettingsHelper_1 = require("../services/SettingsHelper");
class SetupService {
    constructor(vuexStore) {
        this.vuexStore = vuexStore;
        this.cookieService = new CookieStorageService_1.CookieStorageService();
        this.commonState = vuex_module_decorators_1.getModule(CommonModule_1.default, this.vuexStore);
        this.client = new QuestelServicesClient_1.QuestelServicesClient(vuexStore, '');
    }
    initializeApp() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            let currentAppUrl = window.localStorage.getItem('ApplicationUrl');
            let token = '';
            let authentication_url = '';
            let impersonatingAuthToken = '';
            if (currentAppUrl) {
                yield this.getCookieData(currentAppUrl, "Token").then((result) => {
                    token = result.Data;
                })
                    .catch(() => {
                    console.log("There was an error getting the User Token");
                });
                yield this.getCookieData(currentAppUrl, "ImpersonatingToken").then((result) => {
                    impersonatingAuthToken = result.Data;
                })
                    .catch(() => {
                    console.log("There was an error getting the User Impersonated Token");
                });
                yield this.getCookieData(currentAppUrl, "AuthenticationUrl").then((result) => {
                    authentication_url = result.Data;
                })
                    .catch(() => {
                    console.log("There was an error getting the AuthenticationUrl");
                });
                yield SettingsHelper_1.SettingsHelper.getApplicationSettings('/api/v1')
                    .then((result) => {
                    let appSettings = {
                        ApplicationUrl: result.ServiceBaseUrl,
                        ActiveDirectoryLoginPath: result.AdLoginPath,
                        LogoutPath: result.LogoutPath,
                        TokenRefreshPath: result.TokenRefreshPath
                    };
                    this.commonState.setApplicationSettings(appSettings);
                })
                    .catch(() => {
                    console.log("There was an error getting the application settings");
                });
            }
            else {
                // Get the authentication token from the cookies if exist and set it back
                token = this.cookieService.getItem(CookieKeysEnum_1.CookieKeysEnum.Token);
                // Get the authentication URL from the cookies if exist and set it back
                authentication_url = this.cookieService.getItem(CookieKeysEnum_1.CookieKeysEnum.AuthenticationUrl);
            }
            if (token) {
                yield this.commonState.setAuthToken(token);
            }
            if (impersonatingAuthToken) {
                yield this.commonState.setImpersonatingAuthToken(impersonatingAuthToken);
            }
            if (authentication_url) {
                yield this.commonState.setAuthenticationUrl(authentication_url);
            }
            resolve();
        }));
    }
    getCookieData(currentAppUrl, cookieName) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.client.getJson(`${currentAppUrl}/api/UserAccount/get-cookie?` + new URLSearchParams({
                CookieName: cookieName
            }));
        });
    }
}
exports.SetupService = SetupService;
//# sourceMappingURL=SetupService.js.map